export default __webpack_public_path__ + "static/media/soup.87f3be93.jpeg";